import state from '../state'
import { q1O } from '../util/nE'
import Flickity from 'flickity'
import gsap from 'gsap'
import SplitText from 'gsap/SplitText'
gsap.registerPlugin(SplitText)

class HeroCentered {
  constructor (el) {
    this.el = el
    this.title = this.el.querySelector('.hero-centered__title')
    this.list = this.el.querySelector('.hero-centered__inner')
    this.content = this.el.querySelector('.hero-centered__content')
    this.items = this.el.querySelectorAll('.hero-centered__item')
  }

  init () {
    this.isXl = false
    const mm = gsap.matchMedia()
    mm.add(state.queries.xl, () => {
      this.isXl = true
    })

    this.buildTimelineIn()
    this.buildFlickity()
  }

  buildSplitText (el) {
    if (!el) {
      return
    }
    const split = new SplitText(el, {
      type: 'chars, words, lines',
      linesClass: 's-line u-t overflow-hidden',
      lineThreshold: 10,
    })

    return split
  }

  buildTimelineIn () {
    this.split = this.buildSplitText(this.title)

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.el,
      },
      defaults: {
        duration: 1.5,
        ease: (t) => {
          return q1O(t)
        },
      },
    })

    tl.set(this.el, { autoAlpha: 1 })
    tl.fromTo(
      this.content, {
        autoAlpha: 0,
        yPercent: 100,
      }, {
        autoAlpha: 1,
        yPercent: 0,
      }
    )
    if (this.title) {
      tl.fromTo(this.split.chars, {
        yPercent: 100,
        autoAlpha: 0,
      }, {
        yPercent: 0,
        autoAlpha: 1,
        stagger: 0.021,
      }, 0)
    }

    this.items.forEach((item, index) => {
      const imageWrapper = item.querySelector('.hero-centered__media-wrapper')
      const image = imageWrapper.querySelector('.c-media')
      tl.fromTo(imageWrapper, {
        clipPath: 'inset(50% round 8px)',
        x: -400,
        y: 100,
      }, {
        clipPath: 'inset(0% round 8px)',
        x: 0,
        y: 0,
        ease: (t) => {
          return q1O(t)
        },
      }, 0.05 * index)

      tl.to(imageWrapper, {
        clipPath: 'inset(0% round 8px)',
        ease: (t) => {
          return q1O(t)
        },
      }, 0)

      tl.to(image, {
        scale: 1,
        ease: (t) => {
          return q1O(t)
        },
      }, 0)
    })
  }

  buildFlickity () {
    this.flickity = new Flickity(this.list, {
      accessibility: true,
      resize: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      percentPosition: true,
      setGallerySize: true,
      imagesLoaded: true,
      draggable: false,
      freeScroll: true,
      freeScrollFriction: 0.03,
    })

    this.currentPosition = this.flickity.x
    gsap.ticker.add(this.onTick.bind(this))
  }

  onTick () {
    if (this.isXl) {
      if (!this.lastDirection) this.lastDirection = 1

      const baseSpeed = 1.5
      const velocity = state.smoothScroll.lenis.velocity * 0.85
      const direction = velocity !== 0 ? state.smoothScroll.lenis.direction : this.lastDirection

      this.lastDirection = direction

      this.flickity.x += (baseSpeed + Math.abs(velocity)) * direction
    } else {
      this.currentPosition += 0.5
      this.flickity.x = this.currentPosition
    }
    this.flickity.settle(this.flickity.x)
  }

  destroy () {
    this.flickity.destroy()
    gsap.ticker.remove(this.onTick)
  }
}

export default HeroCentered



//////////////////
// WEBPACK FOOTER
// ./scripts/components/HeroCentered.js
// module id = 35
// module chunks = 0